// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-impact[data-v-7a6661f0]{margin-bottom:48px}", ""]);
// Exports
module.exports = exports;
